import type React from "react";
import {
  Collapsible as ShadcnCollapsible,
  CollapsibleTrigger as ShadcnCollapsibleTrigger,
  CollapsibleContent as ShadcnCollapsibleContent,
} from "src/shadcn/components/collapsible";

const Collapsible = (props: React.ComponentProps<typeof ShadcnCollapsible>) => (
  <ShadcnCollapsible {...props} />
);

const CollapsibleTrigger = (
  props: React.ComponentProps<typeof ShadcnCollapsibleTrigger>
) => <ShadcnCollapsibleTrigger {...props} />;

const CollapsibleContent = (
  props: React.ComponentProps<typeof ShadcnCollapsibleContent>
) => <ShadcnCollapsibleContent {...props} />;

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
